var map = {
	"./1.png": "cab0",
	"./2.png": "355b",
	"./2560_1440.png": "8fa3",
	"./3.png": "8318",
	"./arrow-left.svg": "89b6",
	"./arrow-right.svg": "b281",
	"./balloons.png": "4f87",
	"./children.png": "dc82"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ff4e";